import React from 'react';
import { taxLabel } from '../../../helpers/taxHelper';
import Currency from '../../../helpers/currency';
import StandortLink from '../../components/VHost/StandortLink';
import { useSelector } from 'react-redux';
import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';
import classnames from 'classnames';

function QuantityBox({ isBattery, lieferweg, variant, isOfferActive, isSelected, onSelect, quantity, isFreeShipping }) {
    const markenStandort = useSelector(markenStandortSelector)
    const isShippingProduct = lieferweg.legalType === 'online-kauf';
    const isReservationProduct = lieferweg.legalType === "reservierung";
    const isNoa = markenStandort.gesellschafterNr === "035";
    const scrollToMap = () => {
        const mapElement = document.getElementById('locations-for-product');
        if (mapElement) {
            mapElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    return (

        <label style={{ width: '100%', display: 'block', cursor: 'pointer' }}>
            <div className={isSelected ? "uk-background-muted quality-box-card" : "uk-border uk-border-muted quality-box-card"} data-uk-margin="" >
                <div className="uk-grid-small" data-uk-grid="">
                    <div className="uk-width-auto" style={{ paddingTop: "10px" }}>
                        <input
                            type="radio"
                            name={`shipping-selection-${variant._id}-${lieferweg.legalType}`}
                            className="uk-radio"
                            value={variant.id}
                            checked={isSelected}
                            onChange={onSelect}
                            style={{ marginRight: "10px", cursor: "pointer" }}
                            tabIndex={0}
                            aria-label={`${isShippingProduct ? 'Lieferung' : 'Abholung'} ${variant.additionalPickup ? 'Option (mit Pfeiltaste wählbar)' : ''}`}
                            aria-checked={isSelected}
                        />
                    </div>
                    <div className='uk-width-1-2 uk-width-1-3@s uk-width-1-2@l  uk-width-1-2@m '>
                        <div className='uk-flex uk-flex-column'>
                            <span className='uk-text-left uk-text-bold' style={{ 'font-size': '1.375rem' }}>{isShippingProduct ? 'Lieferung' : 'Abholung'}</span>
                            <div className="uk-text-small uk-text-muted uk-text-left">
                                {variant.faktor && variant.masseinheit && (
                                    <div>
                                        (Grundpreis pro {variant.masseinheit} ={' '}
                                        <Currency quantity={variant.vk_preis / variant.faktor} />)
                                    </div>
                                )}
                                {isBattery && <p>zzgl.  <Currency quantity={variant.batterieDeposit * quantity ?? 7.40 * quantity} /> Pfand lt. §10 BattG.</p>}
                                <div className='uk-margin-small-bottom' tabIndex={-1}>Preis inkl. {taxLabel()} MwSt.</div>
                                {isShippingProduct && (
                                    isFreeShipping ? (
                                        <div>
                                            <StandortLink className="uk-link focus" to="/lieferUndVersand" ariaLabel="Informationen zu Versandkosten">
                                                <u className='uk-text-bold uk-text-decoration-none' style={{ color: "#128001" }}>Versandkostenfrei</u>
                                            </StandortLink>
                                        </div>
                                    ) : (
                                        <div>
                                            zzgl. <Currency quantity={lieferweg?.versandkosten?.pauschale1} />{' '}
                                            <StandortLink
                                                className="uk-link focus"
                                                to="/lieferUndVersand"
                                                ariaLabel="Informationen zu Versandkosten"
                                            >
                                                <u>Versandkosten</u>
                                            </StandortLink>
                                        </div>

                                    )
                                )}
                                {isReservationProduct && (
                                    <div>
                                        Abholbar an <a role='button' tabIndex={0} href="#locations" onClick={scrollToMap} className="uk-text-emphasis" style={{ textDecoration: 'underline' }}> diesen Standorten</a>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    {/* Price displayed */}
                    <div className="uk-width-2-3 uk-flex uk-flex-column uk-text-right uk-width-expand uk-padding-remove-left">
                        <div className="uk-flex uk-flex-middle uk-flex-column uk-flex-end">
                            {variant.deleted && <div className="uk-text-center">
                                <span className="aps-price">
                                    nicht verfügbar
                                </span>
                            </div>}
                            {!variant.deleted && (
                                <>
                                    {((!isReservationProduct && !variant.isOwnArticle ? !variant.aktionsPreis : isReservationProduct && variant.isOwnArticle ? !variant.aktionsPreisPickup : !variant.aktionsPreis) || !isOfferActive) ? (
                                        <span className="aps-price">
                                            {isReservationProduct && variant.isOwnArticle ? (
                                                <>
                                                    {!variant.pickup_preis ? (
                                                        <Currency quantity={variant.vk_preis * quantity} />
                                                    ) : (
                                                        <Currency quantity={variant.pickup_preis * quantity} />
                                                    )}
                                                </>
                                            ) : (
                                                <Currency quantity={variant.vk_preis * quantity} />
                                            )}
                                        </span>
                                    ) : (((variant.aktionsPreis && variant.aktionsPreis >= variant.vk_preis) &&
                                        (variant.aktionsPreisPickup && variant.aktionsPreisPickup >= variant.pickup_preis)) ? (
                                        <div className="uk-text-center">
                                            <span className={classnames('aps-price', { 'noaPrice': isNoa })}>
                                                {isReservationProduct && variant.isOwnArticle ? (
                                                    <>
                                                        {!variant.pickup_preis ? (
                                                            <Currency quantity={variant.vk_preis * quantity} />
                                                        ) : (
                                                            <Currency quantity={variant.pickup_preis * quantity} />
                                                        )}
                                                    </>
                                                ) : (
                                                    <Currency quantity={variant.vk_preis * quantity} />
                                                )}
                                            </span>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="uk-width-auto uk-flex uk-flex-column uk-text-right uk-width-expand">
                                                <div className={classnames(isNoa ? "uk-flex uk-flex-end uk-flex-center noaOldPrice" : "uk-flex uk-flex-column uk-flex-middle uk-flex-center")}>
                                                    <div className="uk-h6 aps-price-old uk-margin-remove-top uk-margin-remove-bottom">
                                                        <span className="statt">statt </span>
                                                        {isReservationProduct && variant.isOwnArticle ? (
                                                            <span>
                                                                {!variant.pickup_preis ? (
                                                                    <Currency quantity={variant.vk_preis * quantity} />
                                                                ) : (
                                                                    <Currency quantity={variant.pickup_preis * quantity} />
                                                                )}
                                                            </span>
                                                        ) : (
                                                            <span><Currency quantity={variant.vk_preis * quantity} /></span>
                                                        )}
                                                    </div>
                                                    <span className={classnames('aps-price uk-text-offer uk-margin-remove-top uk-margin-remove-bottom uk-flex uk-flex-middle uk-flex-center', { 'noaPrice': isNoa })}>
                                                        {!isNoa && <span className='percentage uk-flex uk-flex-middle uk-flex-center' aria-label='rabattierter Artikel'>%</span>}
                                                        {isReservationProduct && variant.isOwnArticle ? (
                                                            <>
                                                                {!variant.aktionsPreisPickup ? (
                                                                    <Currency quantity={variant.aktionsPreis * quantity} />
                                                                ) : (
                                                                    <Currency quantity={variant.aktionsPreisPickup * quantity} />
                                                                )}
                                                            </>
                                                        ) : (
                                                            <Currency quantity={variant.aktionsPreis * quantity} />
                                                        )}
                                                    </span>
                                                </div>
                                            </div>
                                        </>
                                    )
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </label>
    );
}

export default QuantityBox;
